"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countChildren = exports.countDependents = void 0;
const __1 = require("../../");
/**
 * Number of non-applicant members
 *
 * @public
 * @param {IMember[]} members - Members to count.
 *
 * @returns {number} - Number of dependents.
 *
 * @example
 * ```ts
 * const total = countDependents(members);
 * ```
 */
function countDependents(members) {
    return (0, __1.findDependents)(members).length;
}
exports.countDependents = countDependents;
/**
 * Number of children members
 *
 * @public
 * @param {IMember[]} members - Members to count.
 *
 * @returns {number} - Number of children.
 *
 * @example
 * ```ts
 * const total = countChildren(members);
 * ```
 */
function countChildren(members) {
    return (0, __1.findChildren)(members).length;
}
exports.countChildren = countChildren;
//# sourceMappingURL=count-members.js.map